<ngx-slider [options]="options"
            [value]="singleValue"
            (valueChange)="onChange($event)"
            [manualRefresh]="manualRefresh">
</ngx-slider>
